//Install
import React, { Component } from "react";
//Install
import { Row, Col } from "react-bootstrap";
//Install
import { Swiper, SwiperSlide } from "swiper/react";
//Install
import { Navigation, Pagination, Autoplay } from "swiper/modules";
//Install
import T052LZ from "../../Media/Image/028.jpg";
//Install
import C833IB from "../../Media/Image/037.jpg";
//Install
import Q71Q86 from "../../Media/Image/039.jpg";
//Install
import R79SK9 from "../../Media/Image/041.jpg";

//Element
class P57859 extends Component {
    //Element
    render() {
        //Element
        const C84K7A = {
            //Element
            spaceBetween: "0",
            //Element
            slidesPerView: "1",
            //Element
            autoplay: {
                //Element
                delay: 2500
            },
            //Element
            loop: true,
            //Element
            freeMode: true,
            //Element
            breakpoints: {
                //Element
                320: {
                    //Element
                    slidesPerView: 1
                },
                //Element
                360: {
                    //Element
                    slidesPerView: 1
                },
                //Element
                480: {
                    //Element
                    slidesPerView: 1
                },
                //Element
                504: {
                    //Element
                    slidesPerView: 1
                },
                //Element
                600: {
                    //Element
                    slidesPerView: 1
                },
                //Element
                768: {
                    //Element
                    slidesPerView: 1
                },
                //Element
                1024: {
                    //Element
                    slidesPerView: 1
                },
                //Element
                1280: {
                    //Element
                    slidesPerView: 1
                }
            },
            //Element
            modules: [Navigation, Pagination, Autoplay]
        }
        //Element
        const Content = React.createElement(Row, {},
            //Element
            React.createElement(Col, { md: 4 },
                //Element
                React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB f029qa" },
                    //Element
                    React.createElement("span", { className: "S6pt64 C96Q4r pEO064 a527eB q035zf" },
                        //Element
                        "01"
                    ),
                    //Element
                    React.createElement("span", { className: "S6pt64 C96Q4r pEO064 a527eB g371o1" },
                        //Element
                        "Elektriğe Temas Edin, Geleceğe Bağlanın."
                    ),
                    //Element
                    React.createElement("h2", { className: "S6pt64 C96Q4r pEO064 a527eB tv2821" },
                        //Element
                        "Kesintisiz Enerji,",
                        //Element
                        React.createElement("br", {}),
                        //Element
                        React.createElement("em", {},
                            //Element
                            "Sürdürülebilir"
                        ),
                        //Element
                        React.createElement("br", {}),
                        //Element
                        "Gelecek"
                    )
                )
            ),
            //Element
            React.createElement(Col, { md: 8 },
                //Element
                React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB j392d8" },
                    //Element
                    React.createElement(Swiper, { className: "S6pt64 C96Q4r pEO064 a527eB a129ro", ...C84K7A },
                        //Element
                        React.createElement(SwiperSlide, {},
                            //Element
                            React.createElement("picture", { className: "S6pt64 C96Q4r pEO064 a527eB u3177a" },
                                //Element
                                React.createElement("img", { alt: "Güvenli Enerji, Sürdürülebilir Gelecek", title: "Güvenli Enerji, Sürdürülebilir Gelecek", src: T052LZ, width: "856", height: "auto" })
                            )
                        ),
                        //Element
                        React.createElement(SwiperSlide, {},
                            //Element
                            React.createElement("picture", { className: "S6pt64 C96Q4r pEO064 a527eB u3177a" },
                                //Element
                                React.createElement("img", { alt: "Güvenli Enerji, Sürdürülebilir Gelecek", title: "Güvenli Enerji, Sürdürülebilir Gelecek", src: C833IB, width: "856", height: "auto" })
                            )
                        ),
                        //Element
                        React.createElement(SwiperSlide, {},
                            //Element
                            React.createElement("picture", { className: "S6pt64 C96Q4r pEO064 a527eB u3177a" },
                                //Element
                                React.createElement("img", { alt: "Güvenli Enerji, Sürdürülebilir Gelecek", title: "Güvenli Enerji, Sürdürülebilir Gelecek", src: R79SK9, width: "856", height: "auto" })
                            )
                        )
                    ),
                    //Element
                    React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB a725gw" },
                        //Element
                        React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB y48p90" },
                            //Element
                            "Temas Elektrik Taahhüt Olarak Elektriği Yalnızca Aktarmıyoruz Geleceği Şekillendiriyoruz. Elektrik Taahhüt, Bakım ve Onarım, Proje Geliştirme, Enerji Sistemleri ve Otomasyon Alanlarında Deneyimli Kadromuz ve Yenilikçi Yaklaşımımızla Çözüm Üretiyoruz."
                        ),
                        //Element
                        React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB y48p90" },
                            //Element
                            "Kamu Kurumlarından Sanayi Tesislerine, KOBİ’lerden Özel Projelere Kadar, Her Çalışmamızda Sürdürülebilirlik, Kalite ve Güven Temel Önceliklerimizdir."
                        ),
                        //Element
                        React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB y48p90" },
                            //Element
                            "Bizim İçin Her Kablo Bir Bağlantıdan Daha Fazlasıdır. Yarını Bugüne Taşıyan Bir Hattır, Güvenli ve Sağlam Bir Yapının Temelini Oluşturur. Biriktirdiğimiz Tecrübe ve Modern Yaklaşımlarımızla Elektriği Sürdürülebilir Şekilde Kullanıyor Her Çalışmayı Geleceğe Güvenle Taşınan Bir Yatırım Olarak Görüyoruz."
                        ),
                        //Element
                        React.createElement("a", { className: "S6pt64 C96Q4r pEO064 a527eB q74b13", href: "/hakkimizda" },
                            //Element
                            "Yakından Bakın"
                        )
                    )
                )
            )
        )
        //Element
        return (
            Content
        );
    }
}
//Element
export default P57859;